<template>
  <div>
    <v-card>
      <v-card-title v-if="this.formaction == 'create'">
        <span class="headline">Add Game</span>
      </v-card-title>
      <v-card-title v-if="this.formaction == 'edit'">
        <span class="headline">Edit Game {{this.Form.gameName}}</span>
      </v-card-title>

      <v-card-text>
        <small>*indicates required field</small>

        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs6>
              <v-text-field
                v-model="Form.gameName"
                v-validate="'required'"
                data-vv-rules="required"
                data-vv-scope="gameForm"
                :error-messages="errors.collect('gameForm.gameName')"
                hide-details
                :counter="50"
                label="Game Name*"
                name="gameName"
              />
            </v-flex>

            <!-- Date -->
            <v-flex xs6>
              <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="Form.date"
                persistent
                lazy
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="Form.date"
                    label="Game Date"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="Form.date" style="height:450px">
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="modal = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.dialog.save(Form.date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <!---End Date-->

            <v-flex xs4>
              <v-text-field
                v-model="Form.competition"
                v-validate="'required'"
                data-vv-rules="required"
                data-vv-scope="gameForm"
                :error-messages="errors.collect('gameForm.competition')"
                hide-details
                :counter="50"
                label="Competition*"
                name="competition"
              />
            </v-flex>
            <v-flex xs4>
              <v-text-field
                v-model="Form.venue"
                v-validate="'required'"
                data-vv-rules="required"
                data-vv-scope="gameForm"
                :error-messages="errors.collect('gameForm.venue')"
                hide-details
                :counter="50"
                label="Venue*"
                name="venue"
              />
            </v-flex>
            <v-flex xs4>
              <v-text-field
                v-model="Form.attendence"
                :counter="50"
                label="Attendence"
                name="attendence"
              />
            </v-flex>
            <v-flex xs4>
              <v-text-field
                v-model="Form.tvChannel"
                :counter="50"
                label="TV Channel"
                name="tvChannel"
              />
            </v-flex>
            <v-flex xs4>
              <v-text-field v-model="Form.result" :counter="50" label="Result" name="result" />
            </v-flex>
            <v-flex xs4>
              <v-text-field
                v-model="Form.status"
                v-validate="'required'"
                data-vv-rules="required"
                data-vv-scope="gameForm"
                :error-messages="errors.collect('gameForm.status')"
                hide-details
                :counter="50"
                label="Status*"
                name="status"
              />
            </v-flex>
            <v-flex xs6>
              <v-select
                v-model="Form.sponsorID"
                :items="sponsors"
                item-text="name"
                item-value="id"
                chips
                label="Sponsors"
                multiple
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-select
                v-model="Form.portalID"
                :items="portallist"
                item-text="portalName"
                item-value="id"
                chips
                multiple
                label="Portals"
              ></v-select>
            </v-flex>
            <!-- Filestack upload button -->
            <v-flex xs12 sm12 class="text-xs-center">
              <!-- Filestack display icon -->
              <vdownload
                v-if="Form.videoLink !== null"
                url="https://cdn.filestackcontent.com/"
                :apikey="integration.fsAPIKey"
                :policy="integration.fsReadPolicy"
                :signature="integration.fsReadSignature"
                :handle="Form.videoLink.handle"
                width="100%"
                height="200"
                tag="iframe"
                :v-bind:embed="true"
                classes
              ></vdownload>
              <vupload
                :maxfiles="1"
                :apikey="integration.fsAPIKey"
                :path="portal.active.id + '/videos/'"
                :accept="['video/*']"
                :policy="integration.fsUploadPolicy"
                :signature="integration.fsUploadSignature"
                :label="changeVideoLabel(Form.videoLink)"
                classes="secondary v-btn white--text"
                v-on:result="uploadResult = $event"
              ></vupload>
              <v-btn
                v-if="Form.videoLink !== null"
                @click="Form.videoLink = null"
                class="primary white--text"
              >Delete</v-btn>
            </v-flex>

            <!--v-flex xs4>
              portal {{ portal.active.id }}
              <vupload
                :maxfiles="1"
                apikey="A9Qx1trOUQuO4jYrB95b2z"
                :path="portal.active.id + '/videos/'"
                v-bind:accept="['video/*']"
                v-bind:security="{
        policy:
          'eyJjYWxsIjpbInBpY2siLCJyZWFkIiwid3JpdGUiLCJzdG9yZSJdLCJleHBpcnkiOjE5MjQ5OTIwMDB9',
        signature:
          'e0cfd5fd0fc1aeb84a0d4d34fd6bf593c139a8a0741989e8aa5a1eab5c6135d2'
      }"
                label="Upload video"
                classes="secondary v-btn white--text"
                v-on:result="uploadResult = $event"
              ></vupload>
            </v-flex-->

            <!--v-flex xs12 v-if="Form.videoLink">
            <!- Filestack display icon-->
            <!--vdownload
                  url="https://cdn.filestackcontent.com/"
                  :apikey="integration.fsAPIKey"
                  :policy="integration.fsReadPolicy"
                  :signature="integration.fsReadSignature"
                  :handle="Form.videoLink.handle"
                  width="100%"
                  height="300"
                  tag="iframe"
                  :v-bind:embed="true"
                  classes="red white--text"
                ></vdownload>
            </v-flex-->

            <!--v-flex xs12>
              <v-card v-for="file in files[0]" v-bind:key="file.uploadId">
                <vdownload
                  url="https://cdn.filestackcontent.com/"
                  apikey="A9Qx1trOUQuO4jYrB95b2z"
                  policy="eyJjYWxsIjpbInBpY2siLCJyZWFkIiwid3JpdGUiLCJzdG9yZSJdLCJleHBpcnkiOjE5MjQ5OTIwMDB9"
                  signature="e0cfd5fd0fc1aeb84a0d4d34fd6bf593c139a8a0741989e8aa5a1eab5c6135d2"
                  :handle="file.handle"
                  width="100%"
                  height="300"
                  tag="iframe"
                  :v-bind:embed="true"
                  classes="red white--text"
                ></vdownload>
              </v-card>
            </v-flex-->
            <!-- <v-flex xs6>
          <v-select
            v-model="Form.sponsorID"
            :items="sponsors"
            item-text="name"
            item-value="id"
            chips
            label="Sponsors"
            multiple
          ></v-select>
            </v-flex>-->
            <!-- <v-flex xs12>
              <pre align="left">{{ Form }}</pre>
            </v-flex>-->
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.native="CloseDialog()">Close</v-btn>
        <v-btn color="blue darken-1" flat @click.native="SaveDocument('gameForm')">Save</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import adminSchema from "@/schemas/admin.json";
import vupload from "@/components/filestack/vupload.vue";
import vdownload from "@/components/filestack/vdownload.vue";

export default {
  //filestack
  components: {
    vupload,
    vdownload
  },
  props: {
    admin: {
      type: Object,
      default() {
        return {};
      }
    },
    portal: {
      type: Object,
      default() {
        return {};
      }
    },
    form: {
      type: Object,
      default() {
        return {};
      }
    },
    formaction: {
      type: String,
      default: ""
    },
    schema: {
      type: Object,
      default() {
        return {};
      }
    },
    portallist: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data: () => ({
    portalSelect: [],
    Form: {
      id: null,
      attendence: null,
      competition: null,
      date: new Date().toISOString().substr(0, 10),
      result: null,
      sponsorID: [],
      portalID: [],
      status: "draft",
      tvChannel: null,
      venue: null,
      videoLink: null
    },

    /*
      date: new Date().toISOString().substr(0, 10)
    },
    */

    modal: false,
    sponsors: [],
    //filestack
    dialog: false,
    displayIcon: true,
    uploadResult: "Nothing",
    apikey: "A9Qx1trOUQuO4jYrB95b2z",
    downloadurl: "https://cdn.filestackcontent.com/",
    output: "",
    readpolicy:
      "eyJjYWxsIjpbInBpY2siLCJyZWFkIiwid3JpdGUiLCJzdG9yZSJdLCJleHBpcnkiOjE5MjQ5OTIwMDB9",
    readsignature:
      "e0cfd5fd0fc1aeb84a0d4d34fd6bf593c139a8a0741989e8aa5a1eab5c6135d2"
  }),
  computed: {
    ...mapState({
      Documents: state => state.Admin.Documents,
      OtherDocuments: state => state.Admin.OtherDocuments,
      integration: state => state.integration
    })
  },
  watch: {
    admin: {
      handler: function() {
        this.readDocuments();
      },
      deep: true
    },
    OtherDocuments: {
      handler: function() {
        this.sponsors = this.OtherDocuments;
      },
      immediate: true,
      deep: true
    },
    OtherDocumentsResult: {
      handler: function() {
        this.readDocuments();
      },
      immediate: true,
      deep: true
    },

    form: {
      handler: function() {
        if (this.form.id) {
          this.Form.id = this.form.id;
        }
        if (this.form.portalID) {
          this.Form.portalID = this.form.portalID;
        }
        if (this.form.date) {
          this.Form.date = this.form.date;
        }
        if (this.form.attendence) {
          this.Form.attendence = this.form.attendence;
        }
        if (this.form.competition) {
          this.Form.competition = this.form.competition;
        }
        if (this.form.gameName) {
          this.Form.gameName = this.form.gameName;
        }
        if (this.form.result) {
          this.Form.result = this.form.result;
        }
        if (this.form.sponsorID) {
          this.Form.sponsorID = this.form.sponsorID;
        }
        if (this.form.status) {
          this.Form.status = this.form.status;
        }
        if (this.form.tvChannel) {
          this.Form.tvChannel = this.form.tvChannel;
        }
        if (this.form.venue) {
          this.Form.venue = this.form.venue;
        }
        if (this.form.videoLink) {
          this.Form.videoLink = this.form.videoLink;
        }
      },
      deep: true
    },
    uploadResult() {
      this.Form.videoLink = this.uploadResult[0];
    }
  },
  methods: {
    changeVideoLabel: function(icon) {
      if (icon) {
        return "Change video";
      } else {
        return "Upload video";
      }
    },

    CloseDialog() {
      this.$emit("Dialog", false);
      // this.uploadResult = []
    },
    SaveDocument(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (!valid) {
          // do nothing
        } else {
          // console.log("Save Document + " + this.formaction);
          //this.Form.videoLink = this.uploadResult[0];
          //console.log("video link: " + JSON.stringify(this.Form.videoLink, null, 2));
          switch (this.formaction) {
            case "create":
              this.$store.dispatch("Settings/createDocument", [
                this.admin.Collection,
                this.Form,
                "Settings/setDocumentResult"
              ]);
              break;
            case "edit":
              var id = this.Form.id;
              // console.log(JSON.stringify(this.Form, null, 2));
              this.Form = this.$omit(this.Form, [
                "vgt_id",
                "originalIndex",
                "id"
              ]);
              // console.log(JSON.stringify(this.Form, null, 2));
              this.$store.dispatch("Settings/updateDocument", [
                this.admin.Collection,
                id,
                this.Form
              ]);
              break;
            default:
              break;
          }
          this.CloseDialog();
        }
      });
    },
    readDocuments() {
      this.$store.dispatch("Admin/readOtherDocuments", [
        "sponsors",
        this.portal.active.id,
        "Admin/setOtherDocuments"
      ]);
    },
    CreateURL(handle) {
      // console.log("new handle is")
      return (
        this.downloadurl +
        //this.uploadResult[0].key
        this.apikey +
        this.output +
        "/security=policy:" +
        this.readpolicy +
        ",signature:" +
        this.readsignature +
        "/" +
        handle
      );
    }
  },
  mounted() {
    this.readDocuments();
    this.$store.dispatch("portal/readLookups", [
      "lookups",
      this.portal.active.id,
      "portal/setLookups",
      "portal/setLookupsResult"
    ]);
  }
};
</script>

<style>
.input-container {
  vertical-align: middle !important;
  display: flex;
  width: 100%;
  margin-bottom: 15px;
}
</style